// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "31827c1-dirty",
    "hash": "31827c1",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "31827c1-dirty",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
